import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import DropdownMenu from './DropdownMenu';
import { closeFullscreenMobileSubnav } from '../actions/menu';

const MobileFullscreenSubnav = () => {
	const dispatch = useDispatch();
	const fullscreenData = useSelector(
		(state) => state.menu.fullscreenMobileSubnavData
	);
	const [isAnimating, setIsAnimating] = useState(false);
	const [isClosing, setIsClosing] = useState(false);

	const { subnavItems } = fullscreenData;

	useEffect(() => {
		// Trigger slide-in animation on mount
		setTimeout(() => setIsAnimating(true), 10);
	}, []);

	const handleBackClick = () => {
		setIsClosing(true);
		setIsAnimating(false);
		// Wait for animation to complete before dispatching close
		setTimeout(() => {
			dispatch(closeFullscreenMobileSubnav());
		}, 300);
	};

	return (
		<div
			data-testid="mobile-fullscreen-subnav-container"
			className={`mobile-fullscreen-subnav panel panel-default${
				isAnimating ? ' slide-in' : ''
			}${isClosing ? ' slide-out' : ''}`}
		>
			<div
				className="mobile-fullscreen-subnav-header"
				data-testid="mobile-fullscreen-subnav-header"
			>
				<div
					className="mobile-fullscreen-back-button"
					onClick={handleBackClick}
					onKeyDown={(e) => {
						if (e.key === 'Enter' || e.key === ' ') {
							handleBackClick();
						}
					}}
					role="button"
					tabIndex={0}
					aria-label="Back to main menu"
				>
					<i
						data-testid="back-arrow-icon"
						className={`ddc-icon ${
							isClosing
								? 'ddc-icon-arrow1-right'
								: 'ddc-icon-arrow1-left'
						} ddc-icon-size-medium`}
						aria-hidden="true"
					/>
				</div>
			</div>
			<div className="mobile-nav-panel" data-testid="mobile-nav-panel">
				<div className="panel-body" data-testid="panel-body">
					<DropdownMenu subnavItems={subnavItems} />
				</div>
			</div>
		</div>
	);
};

export default MobileFullscreenSubnav;
